export default function Leaderboard({ players, currentPlayerIndex, turnNumber, gameCode, onUndo, canUndo, onQuit, redemption }) {
  const sortedPlayers = [...players].sort((a, b) => b.score - a.score);

  function copyGameLink() {
    const link = `${window.location.origin}/?game=${gameCode}`;
    navigator.clipboard.writeText(link).then(() => {
      alert('Game link copied!');
    }).catch(() => {
      alert(link);
    });
  }

  const inRedemption = !!redemption;
  const remaining = redemption?.remainingPlayerIds?.length ?? 0;
  const headerLabel = inRedemption
    ? `Beat ${redemption.currentTarget.toLocaleString()}`
    : 'Target: 10,000';
  const statusLabel = inRedemption
    ? `Redemption · ${remaining} left`
    : `Turn ${turnNumber}`;

  return (
    <aside className="game-sidebar">
      <div className={`leaderboard-header ${inRedemption ? 'redemption-header' : ''}`}>
        <div className="game-status">{statusLabel}</div>
        <div className="target-score">{headerLabel}</div>
        {gameCode && (
          <button className="game-code-btn" onClick={copyGameLink}>
            {gameCode}
          </button>
        )}
      </div>
      <div className="roster">
        {sortedPlayers.map((player, index) => {
          const rank = index + 1;
          const isActive = player.id === players[currentPlayerIndex]?.id;
          const isLeader = inRedemption && player.id === redemption.currentLeaderId;
          const isTriggerer = inRedemption && player.id === redemption.triggeredById;
          return (
            <div key={player.id} className={`player-card ${isActive ? 'active-turn' : ''} ${isLeader ? 'redemption-leader-card' : ''}`}>
              <div className={`rank ${rank === 1 ? 'rank-1' : ''}`}>{rank}</div>
              <div className="p-info">
                <div className="avatar p-avatar">{player.avatar}</div>
                <div className="p-name">{player.name}</div>
                <div className="p-total">{player.score.toLocaleString()}</div>
                {isTriggerer && <div className="p-tag">triggered</div>}
                {isLeader && !isTriggerer && <div className="p-tag">leading</div>}
              </div>
            </div>
          );
        })}
      </div>
      <div className="leaderboard-footer">
        {canUndo && (
          <button className="btn-undo" onClick={onUndo}>Undo Last Action</button>
        )}
        <button className="btn-quit" onClick={onQuit}>Quit Game</button>
      </div>
    </aside>
  );
}
